


































import {Component, Mixins} from "vue-property-decorator";
import ConvertTimezone from "@/helpers/mixins/ConvertTimezone";
import ChangeAddressList from "@/components/account/accountAddressList/ChangeAddressList.vue";
import {ShoppingAddress} from "@/helpers/interfaces";

@Component({
  components: {
    ChangeAddressList
  }
})
export default class AddressList extends Mixins(ConvertTimezone) {
  public langPath = "MyAccount.addressList.";
  public showTime = false
  public AddressList = [] as ShoppingAddress[]

  public handleAddressList(value: ShoppingAddress[]) {
    this.AddressList = value
  }

  public mosaicMobile(mobile: string) {
    return mobile.slice(0, 3) + "****" + mobile.slice(mobile.length - 4, mobile.length)
  }

  addAddressModal() {
    this.$store.dispatch('TIP_HIDE');
    (this.$refs.ChangeAddressList as ChangeAddressList).addAddressModal()
  }

  editAddressModal(id: number) {
    this.$store.dispatch('TIP_HIDE');
    (this.$refs.ChangeAddressList as ChangeAddressList).editAddressModal(id)
  }

  delAddress(id: number) {
    (this.$refs.ChangeAddressList as ChangeAddressList).delAddress(id)
  }

  setDefault(id: number) {
    (this.$refs.ChangeAddressList as ChangeAddressList).setDefault(id)
  }

}
